import { HTMLAttributes } from "react";

export default function DynamoDB(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
    {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.8856 45.1896H29.3926L37.6685 41.0511L37.8063 40.8564V7.82332L37.6685 7.62762L29.3926 3.49263H28.8794L28.8856 45.1896Z"
        fill="#5294CF"
      />
      <path
        d="M18.1154 45.1896H17.6013L9.33252 41.0511L9.16472 40.7625L9.07959 7.99155L9.33252 7.62762L17.6013 3.49263H18.1218L18.1154 45.1896Z"
        fill="#1F5B98"
      />
      <path
        d="M17.6162 3.49263H29.3847V45.1896H17.6162V3.49263Z"
        fill="#2D72B8"
      />
      <path
        d="M42.0001 23.4043L41.7204 23.3423L37.7273 22.97L37.6681 22.9995L29.3848 22.6682H17.6158L9.33233 22.9995V16.683L9.32366 16.6876L9.33233 16.6691L17.6158 14.7498H29.3848L37.6681 16.6691L40.7132 18.2877V17.2471L42.0001 17.1063L41.8668 16.8464L37.7922 13.9329L37.6681 13.9732L29.3848 11.4065H17.6158L9.33233 13.9732V7.62762L5.00049 12.7025V17.1346L5.03402 17.1104L6.28738 17.2471V18.3091L5.00049 18.9978V23.4078L5.03402 23.4043L6.28738 23.4228V25.2738L5.20601 25.29L5.00049 25.2704V29.6821L6.28738 30.3741V31.4484L5.0544 31.5846L5.00049 31.5441V35.9755L9.33233 41.0511V34.7061L17.6158 37.2728H29.3848L37.6925 34.6986L37.8029 34.747L41.8239 31.8764L42.0001 31.5903L40.7132 31.4484V30.3957L40.5445 30.3283L37.7922 31.8119L37.6925 32.02L29.3848 33.9283V33.9306H17.6158V33.9283L9.33233 32.0119V25.6723L17.6158 26.0024V26.0105H29.3848L37.6681 25.6723L37.8567 25.759L41.7271 25.4257L42.0001 25.2923L40.7132 25.2738V23.4228L42.0001 23.4043Z"
        fill="#1A476F"
      />
      <path
        d="M37.668 34.7061V41.0511L42 35.9755V31.573L37.693 34.6986L37.668 34.7061ZM37.668 32.0258L37.693 32.02L42 29.7035V25.2738L37.668 25.6723V32.0258ZM37.693 16.6749L37.668 16.6691V22.9995L42 23.4043V18.9768L37.693 16.6749ZM37.693 13.9981L42 17.1063V12.7036L37.668 7.62762V13.9732L37.693 13.9819V13.9981Z"
        fill="#2D72B8"
      />
    </svg>
  )
}
